const CLEAR = 'modules/manageCartItem/CLEAR';
const UPDATE = 'modules/manageCartItem/UPDATE';

const reducer = (state = {}, action) => {
  switch (action.type) {
    case CLEAR:
      return {};
    case UPDATE:
      return action.updatedItems;
    default:
      return state;
  }
};

const clearCartItems = () => {
  return { type: CLEAR };
};

const updateCartItems = (updatedItems) => {
  return {
    type: UPDATE,
    updatedItems,
  };
};

export { reducer as default, clearCartItems, updateCartItems };
